<template>
  <nav ref="el" :class="classes">
    <transition>
      <NavigationMenu
        v-if="layout === 'mobile' ? mobileOpen && !!openedItem : !!openedItem"
        :title="getTitleFromHero(openedItem)"
        :slug="openedItem?.slug"
        :cta-link="openedItem?.model?.full_url"
        :items="openedItem?.children"
        :sidelinks="(openedItem?.model?.model as any)?.side_links || []"
        :mobile="layout === 'mobile'"
        @close="openedItem = null"
      />
    </transition>

    <div class="nav__inner">
      <div class="nav__main">
        <ul ref="linksEl" class="nav__links" role="menu">
          <li v-for="item in sortedItems" class="nav__item">
            <nuxt-link :to="path(item.model.full_url || item.slug)" role="menuitem">
              <span @click.prevent="open(item)" role="link">{{ item.title }}</span>
            </nuxt-link>
          </li>
        </ul>
        <button v-if="layout === 'mobile'" class="nav__back" @click="openedItem = null" :aria-label="$t('navigation.back')">
          <Icon name="arrow-left" />
        </button>
      </div>

      <nuxt-link :to="localePath('/')" class="nav__logo" :aria-label="$t('navigation.home')">
        <svg width="110" height="32" fill="#fff" viewBox="0 0 110 32">
          <path d="m100.29 31.67 9.03.02.54-3.85-.49-.05-.6 1.23c-.87 1.81-1.19 1.96-2.93 1.96h-3.16l6.81-10.31-.1-.51-7.65-.02-.83-.64-.19.08-.42 4.08.49.05.4-.82c.99-2.01 1.07-2.04 2.98-2.04h2.81l-6.8 10.31.1.51Zm-12.64-5.76c0 3.66 2.96 5.93 6.04 5.93a9.7 9.7 0 0 0 4.24-.97l.38-3.2-.48-.06-.6 1.25a3.77 3.77 0 0 1-3.54 2.29c-2.27 0-3.73-2.13-3.73-5.23 0-3.13 1.46-5.24 3.73-5.24 1.56 0 2.73.92 3.5 2.44l.49.92.48-.05-.23-2.95A9.62 9.62 0 0 0 93.69 20c-3.08 0-6.04 2.27-6.04 5.93Zm-6.94 5.29.01.5 2.58-.03 2.58.02.01-.5c-1.03-.16-1.55-.4-1.55-.73v-9.09c0-.33.52-.57 1.55-.74l-.01-.5-2.58.03-2.58-.02-.01.5c1.03.16 1.55.4 1.55.73v9.09c0 .33-.52.57-1.55.74Zm-16.6-9.66 3.68 10.2h.65l3.05-8.05 2.92 8.05h.66l3.64-9.63c.42-1.1.62-1.23 1.7-1.48l-.02-.5-1.83.03-2.15-.02-.02.5c1.59.24 1.72.39 1.34 1.5l-2.3 6.64-2.57-7.24c-.16-.44.37-.74 1.57-.9l-.02-.5-2.76.02-2.27-.02-.02.5c1.07.24 1.14.39 1.34.9l.3.84-2.2 6.38-2.52-7.22c-.16-.44.31-.74 1.4-.9l-.01-.5-2.54.02-2.38-.02-.02.5c1.12.24 1.2.39 1.38.9Zm-11.42 4.38c0-3.15 1.42-5.24 3.67-5.24 2.22 0 3.66 2.1 3.66 5.23 0 3.15-1.44 5.24-3.66 5.24-2.25 0-3.67-2.1-3.67-5.23Zm-2.3 0a5.86 5.86 0 0 0 5.97 5.92 5.86 5.86 0 0 0 5.97-5.93A5.86 5.86 0 0 0 56.36 20a5.86 5.86 0 0 0-5.98 5.93ZM37.72 31.2l.02.5 2.57-.03 2.58.02.02-.5c-1.04-.16-1.56-.4-1.56-.73V26.7l1.02-.92 3.52 4.64c.31.43.23.53-1.07.78l.01.5 2.7-.03 2.66.02.01-.5c-1.35-.24-1.43-.34-1.82-.87l-4.48-5.94 2.84-2.6c.92-.82 1.17-.9 2.4-1.15l-.02-.5-2.23.03-2.27-.02-.02.5c1.6.24 1.67.3.78 1.16l-4.03 3.9v-4.33c0-.33.52-.57 1.56-.74l-.02-.5-2.58.03-2.57-.02-.02.5c1.04.16 1.56.4 1.56.73v9.09c0 .33-.52.57-1.56.74Zm-8.18-5.83v-4.52h.93c1.3 0 2.65.6 2.65 2.05 0 1.81-1.42 2.47-2.76 2.47h-.82Zm0 4.03v-3.3h1.1c1.4 0 2.93.69 2.93 2.45 0 1.68-1.19 2.43-2.46 2.43-1.37 0-1.57-.2-1.57-1.58Zm-3.64 1.8.02.5 2.58-.03 2.83.02c2.39.02 4.55-.9 4.55-3.06 0-1.51-1.44-2.78-3.77-2.96 1.95-.41 3.2-1.45 3.2-2.88 0-1.88-2.08-2.67-4.15-2.65l-2.66.02-2.58-.02-.02.5c1.04.16 1.56.4 1.56.73v9.09c0 .33-.52.57-1.55.74ZM14.7 25.9c0-3.14 1.42-5.23 3.66-5.23 2.23 0 3.67 2.1 3.67 5.23 0 3.15-1.44 5.24-3.67 5.24-2.24 0-3.66-2.1-3.66-5.23Zm-2.31 0a5.86 5.86 0 0 0 5.97 5.93 5.86 5.86 0 0 0 5.98-5.93A5.86 5.86 0 0 0 18.35 20a5.86 5.86 0 0 0-5.97 5.93ZM.9 31.2l.02.5h9.7l.54-3.86-.48-.05-.6 1.23c-.86 1.75-1.2 1.96-2.94 1.96h-.93c-1.48 0-1.68-.2-1.68-1.64v-7.97c0-.33.63-.57 1.9-.74l-.02-.5-2.91.03-2.58-.02-.02.5c1.04.16 1.56.4 1.56.73v9.09c0 .33-.52.57-1.56.74Z" />
          <path d="M92.36 5.01h-1.2l-.12.8h1.13l-1.47 6.77c-.5 2.3-.94 3.44-1.77 3.44-.46 0-1.06-.38-1.9-1.15-1.08 1.08-.26 2.05.98 2.05 1.69 0 3.9-1.43 5.28-7.93l.7-3.17h1.8l.13-.8h-1.77l.42-1.93c.25-1.19.42-2.06 1.08-2.06.4 0 .98.36 1.9 1.17 1.07-1.09.25-2.06-1-2.06-1.67 0-3.44 1.43-4.2 4.87Zm-7.85 5.84c0-2.66 1.39-5.35 2.53-5.35.46 0 .7.53.7 1.47 0 2.65-1.39 5.35-2.53 5.35-.47 0-.7-.55-.7-1.47Zm-1.84-.52c0 1.15.63 2.64 2.44 2.64 2.34 0 4.47-2.48 4.47-5.47 0-1.16-.65-2.65-2.46-2.65-2.34 0-4.45 2.48-4.45 5.48Zm-15.6 2v.5h9.72l.53-3.85-.48-.05-.6 1.23c-.86 1.75-1.2 1.96-2.94 1.96h-.93c-1.48 0-1.68-.2-1.68-1.65V7.3l1.33.03c1.3.03 1.65.08 1.94 1.83l.5-.02-.03-2.17.03-2.17-.5-.02c-.29 1.74-.64 1.78-1.94 1.81l-1.33.03V1.98h2.88c1.09 0 1.3.17 1.84 1.3l.6 1.24.5-.05-.23-3.2h-9.2l-.02.5c1.04.16 1.56.41 1.56.74v9.08c0 .33-.52.58-1.56.74Zm-9.7-.11c.99.48 2.08.75 3.6.75 2.31 0 4.32-1.46 4.32-3.55 0-3.96-6.26-2.8-6.26-5.94 0-1 .84-1.66 1.9-1.66 1.21 0 2.05.67 2.77 2.07l.48.92.49-.05-.23-2.88a7.42 7.42 0 0 0-3.27-.75c-2.22 0-3.85 1.46-3.85 3.3 0 3.97 6.18 3.13 6.18 6.03 0 1.15-1.1 1.82-2.31 1.82-1.54 0-2.4-.77-3.08-2.1l-.65-1.27-.49.07.4 3.24ZM43.42 1.28l-.02.49c1.04.16 1.56.41 1.56.74v6.04c0 2.8 1.95 4.42 4.45 4.42 2.67 0 4.78-1.57 4.83-4.54l.07-5.03c.02-1.19.17-1.38 1.52-1.63l-.01-.5-1.98.02-2.16-.01-.01.49c1.54.25 1.67.44 1.69 1.63l.06 4.9c.05 2.3-1.35 3.72-3.34 3.72-1.9 0-3.05-1.36-3.05-3.29V2.51c0-.33.57-.58 1.72-.74l-.01-.5-2.75.02-2.57-.01Zm-10.9 5.77c0-3.14 1.42-5.23 3.67-5.23 2.22 0 3.66 2.09 3.66 5.23 0 3.14-1.44 5.23-3.66 5.23-2.25 0-3.67-2.09-3.67-5.23Zm-2.3 0a5.86 5.86 0 0 0 5.97 5.92 5.86 5.86 0 0 0 5.97-5.92 5.86 5.86 0 0 0-5.97-5.92 5.86 5.86 0 0 0-5.98 5.92ZM15.6 12.33l.02.5 2.58-.02 2.57.02.02-.5c-1.04-.16-1.56-.4-1.56-.74V7.23h5.6v4.36c0 .33-.53.58-1.56.74l.01.5 2.58-.02 2.58.02.01-.5c-1.03-.16-1.55-.4-1.55-.74V2.51c0-.33.52-.58 1.55-.74l-.01-.5-2.58.02-2.58-.01-.01.49c1.03.16 1.55.41 1.55.74v3.95h-5.59V2.5c0-.33.52-.58 1.56-.74l-.02-.5-2.57.02-2.58-.01-.02.49c1.04.16 1.56.41 1.56.74v9.08c0 .33-.52.58-1.56.74Z" />
        </svg>
      </nuxt-link>

      <ul class="nav__right" role="menu">
        <li v-if="$t('navigation.cta1', '_') !== '_'" class="nav__cta">
          <nuxt-link :to="$t('navigation.cta1.link')" class="btn btn--outline" role="menuitem">{{ $t('navigation.cta1') }}</nuxt-link>
        </li>
        <li v-if="$t('navigation.cta2', '_') !== '_'" class="nav__cta">
          <nuxt-link :to="$t('navigation.cta2.link')" class="btn btn--outline" role="menuitem">{{ $t('navigation.cta2') }}</nuxt-link>
        </li>
        <li class="nav__item nav__item--lang">
          <a :href="props.altLangPath" :lang="altLocale" :hreflang="altLocale">
            {{ altLocale.toUpperCase() }}
          </a>
        </li>
      </ul>

      <a v-if="layout === 'mobile'" href="#" class="nav__burger" @click.prevent="onBurgerClick">
        <span>{{ $t('navigation.burger_label') }}</span>
        <Icon :name="mobileOpen ? 'close' : 'menu'" />
      </a>
    </div>
  </nav>
</template>

<script setup lang="ts">
import type { BasicPageablesFragment } from '#gql'
import { onClickOutside } from '@vueuse/core'
import { path } from '~/lib/helpers'

export interface MenuItem {
  title: string
  slug?: string | null
  order?: number | null
  children?: MenuItem[]
  model: {
    model: BasicPageablesFragment
    full_url?: string
  }
}

const props = defineProps<{
  items: MenuItem[]
  altLangPath: string
}>()

const el = ref<HTMLElement | null>(null)
const linksEl = ref<HTMLElement | null>(null)
const openedItem = ref<MenuItem | null>(null)
const sortedItems = computed(() => props.items.sort((a, b) => (a.order || 0) - (b.order || 0)))
const layout = ref('full')
const mobileOpen = ref(false)

const { locale } = useI18n()
const localePath = useLocalePath()
const altLocale = computed(() => locale.value === 'cs' ? 'en' : 'cs')

const getTitleFromHero = (item) =>
  item.model?.model?.hero_settings?.hero_nav_title ||
  item.model?.model?.hero_settings?.hero_title ||
  item.title

const open = (item: MenuItem) => { openedItem.value = openedItem.value === item ? null : item }

const calculateLayout = () => {
  if (!linksEl.value) return true

  const maxWidth = 1276
  const pageMargin = 32
  const logoWidth = 90
  const logoFullWidth = 100
  const langSwitchWidth = 42

  const freeSpaceWhenFull = (maxWidth - logoWidth) / 2 - linksEl.value.clientWidth
  const freeSpaceWhenCompact = (maxWidth - logoFullWidth - langSwitchWidth) - linksEl.value.clientWidth

  const breakpointFull = maxWidth + pageMargin * 2 - freeSpaceWhenFull * 2
  const breakpointCompact = maxWidth + pageMargin * 2 - freeSpaceWhenCompact + 10

  const fitsFull = freeSpaceWhenFull > 0 && window.innerWidth > breakpointFull
  const fitsCompact = freeSpaceWhenFull > 0 && window.innerWidth > breakpointCompact

  let _layout = fitsFull ? 'full' : fitsCompact ? 'compact' : 'mobile'

  layout.value = layout.value === 'mobile' ? 'mobile' : _layout
}

onMounted(() => {
  calculateLayout()
  window.addEventListener('resize', calculateLayout)
})

const close = () => {
  openedItem.value = null
  mobileOpen.value = false
  document.body.style.overflow = ''
}

const onBurgerClick = () => {
  window.scrollTo(0, 0)

  if (mobileOpen.value) {
    close()
  } else {
    mobileOpen.value = true
    setTimeout(() => document.body.style.overflow = 'hidden', 500)
  }
}

// Close the menu on click outside
onClickOutside(el, () => openedItem.value = null)
// ...or route change
useRouter().beforeEach(close)

const classes = computed(() => [
  'nav',
  `nav--${layout.value}`,
  { 'menu-open': layout.value === 'mobile' ? mobileOpen.value && !!openedItem.value : !!openedItem.value },
  { 'mobile-open': mobileOpen.value },
])
</script>

<style lang="scss">
.nav {
  $_: &;
  width: 100%;
  height: _rem(174px);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: _rem(16px);
  z-index: 200;
  padding: _rem(32px) var(--page-margin) 0;
  user-select: none;

  --logo-width: #{_rem(100px)};
  --nav-text-color: var(--color-white);
  --nav-hover-color: var(--color-red);
  --nav-inverse-color: var(--color-white);

  &:has(+ main > .error-page) a {
    --nav-text-color: var(--color-red);
    --nav-hover-color: var(--color-crimson);
    --nav-inverse-color: var(--color-white);
  }

  &.menu-open {
    z-index: 400;
  }

  &.menu-open a, &.mobile-open a {
    --nav-text-color: var(--color-white) !important;
    --nav-hover-color: var(--color-white) !important;
    --nav-inverse-color: var(--color-red) !important;
  }

  &--mobile {
    --logo-width: #{_rem(90px)};
  }

  &__inner {
    width: 100%;
    //max-width: var(--page-width);
    max-width: calc(var(--page-width) + _rem(26px));
    display: flex;
    justify-content: space-between;
  }

  &__main {
    display: flex;
    align-items: center;
    flex: 1 0 calc(50% - var(--logo-width) / 2);
    background-color: transparent;
    overflow: hidden;
    padding-top: _rem(36px);
  }
    &--compact &__main {
      order: 1;
      flex: 1 0;
      justify-content: flex-end;
    }

  &__links {
    display: flex;
    align-items: center;
    column-gap: _rem(20px);
    padding: 0 _rem(36px) 0 0;
    list-style: none;
  }
    &--compact &__links {
      padding-left: _rem(20px);
      padding-right: _rem(10px);
    }

  &__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: _rem(36px) 0 0 _rem(36px);
    margin: 0;
    column-gap: _rem(10px);
    flex: 1 0 calc(50% - var(--logo-width) / 2);
    order: 2;
    list-style: none;
  }
    &--compact &__right {
      flex: 0 1 fit-content;
      padding-left: 0;
    }

  &__item {
    display: inline-block;
    position: relative;
    list-style: none;
    white-space: nowrap;
    
    a {
      display: inline-flex;
      width: 100%;
      color: var(--nav-text-color);
      &:hover { color: var(--nav-hover-color); }

      span {
        width: 100%;
        display: inline-block;
        padding-right: _rem(20px);

        // Caret
        &::after {
          content: '';
          display: block;
          width: _rem(7px);
          height: _rem(7px);
          border-right: 1.5px solid;
          border-bottom: 1.5px solid;
          transform: rotate(45deg);
          position: absolute;
          right: _rem(2px);
          top: calc(50% - _rem(5px));
        }
      }
    }

    &--lang {
      margin-left: _rem(10px);
    }
  }

  &__cta a {
    color: var(--nav-text-color);
    border-color: var(--nav-text-color);
    position: relative;
    &:hover {
      color: var(--nav-inverse-color) !important;
      border-color: var(--nav-hover-color);
      background-color: var(--nav-hover-color);
    }
  }
    &--compact &__cta {
      display: none;
    }

  &__logo {
    flex: 1 0 var(--logo-width);
    min-width: var(--logo-width);
    width: var(--logo-width);
    height: calc(var(--logo-width) * 1.27);
    background: url('/images/nav-logo.png') no-repeat center center; // dark logo
    background-size: 100% 100%;
    display: block;
    position: relative;
    pointer-events: all;

    svg {
      top: 103%;
      width: 100%;
      position: absolute;
      pointer-events: none;
      transition: opacity 150ms ease;
    }

    .menu-open &, .mobile-open & {
      background-position: left bottom !important; // white logo

      svg {
        opacity: 0;
      }
    }
  }
    &--compact &__logo {
      flex: 0;
    }

  &__burger {
    display: flex;
    align-items: center;
    position: absolute;
    top: _rem(84px);
    right: var(--page-margin);
    transform: translateY(-50%);
    color: var(--nav-text-color);
    z-index: 1;
    pointer-events: all;

    span { transition: all 150ms ease }
    .icon { margin-left: _rem(4px) }
  }


  /* ----------- MOBILE ----------- */
  &--mobile {
    height: 100vh;
    height: 100dvh;
    padding: 0;
    overflow: hidden;
    align-items: flex-start;
    transition: background-color 200ms ease;
    pointer-events: none;
    
    &.mobile-open {
      background-color: var(--color-crimson);
      padding-top: _rem(150px);
      pointer-events: all;
    }

    #{$_}__inner {
      flex-direction: column;
      justify-content: space-between;
      overflow-y: auto;
      height: 100%;

      // Edge shadow for scroll
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: _rem(150px);
        width: 100%;
        height: _rem(16px);
        background: linear-gradient(180deg, var(--color-crimson) 0%, transparent 100%);
        z-index: 10;
        opacity: 0;
      }
    }
      &.mobile-open #{$_}__inner {
        &::after {
          opacity: 1;
          transition: opacity 100ms linear 200ms;
        }
      }

    #{$_}__right {
      flex: 0;
      padding: 0 var(--page-margin);
      margin: _rem(32px) 0;
      flex-direction: column;
      gap: _rem(16px);
      transition: all 400ms ease;
    }
      &:not(.mobile-open) #{$_}__right {
        opacity: 0;
        pointer-events: none;
        transform: translate3d(0, _rem(20px), 0);
        transition: none;
      }
      &.menu-open #{$_}__right {
        opacity: 0;
        transform: translate3d(0, _rem(20px), 0);
        transition: transform 200ms ease, opacity 100ms ease-in;
      }
    
    #{$_}__cta {
      width: 100%;
      a { width: 100% }
    }
    #{$_}__item--lang {
      margin: 0;
    }

    #{$_}__logo {
      flex: 0;
      z-index: 1;
      position: absolute;
      top: _rem(16px);
      left: var(--page-margin);

      svg {
        width: _rem(88px);
      }
    }

    #{$_}__back {
      position: absolute;
      display: flex;
      top: _rem(162px);
      left: calc(var(--page-margin) - 8px);
      padding: _rem(4px);
      color: var(--color-white);
      z-index: 1;
      transition: opacity 200ms ease 100ms;
    }
      &:not(.menu-open) #{$_}__back {
        opacity: 0;
        pointer-events: none;
        transition: opacity 100ms ease 0ms;
      }

    #{$_}__main {
      flex: 0 0 auto;
      align-items: flex-start;
    }
      &:not(.mobile-open) #{$_}__main {
        opacity: 0;
        pointer-events: none;
      }

    #{$_}__links {
      width: 100%;
      margin: 0 auto;
      padding: 0 var(--page-margin);
      flex-direction: column;
      align-items: flex-start;
      transition: all 400ms ease;

      li {
        @include heading-font;
        @include generate-delays(5, 100ms);
        width: 100%;
        position: relative;
        font-size: _rem(24px);
        opacity: 0;
        transform: translate3d(0, 0.5em, 0);
        transition: all 200ms var(--ease-smooth-in) var(--delay, 0ms);

        &:not(:last-child)::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0;
          height: 1px;
          opacity: 0.5;
          background-color: var(--color-white);
          transition: width 200ms var(--ease-smooth-in) calc(var(--delay, 0ms) * 1.5);
        }

        a {
          padding: _rem(16px) 0;
          span::after { display: none; }
        }
      }
    }
    &.mobile-open #{$_}__links li {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      &::after { width: 100% }
    }
    &.menu-open #{$_}__links {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }

    &.mobile-open #{$_}__burger {
      span {
        opacity: 0;
        transform: scale(0.9);
        transform-origin: 100% 50%;
      }
    }
  }
}
</style>